import { SET_OBS_IS_VISIBLE } from './constants';

const defaultState = { isVisible: false };

const obsUI = (state = defaultState, action) => {
    switch (action.type) {
        case SET_OBS_IS_VISIBLE:
            return { ...state, isVisible: action.isVisible };

        default:
            return state;
    }
};

export default obsUI;



// WEBPACK FOOTER //
// ./src/containers/Inputs/OBS/reducer.js